import { render, staticRenderFns } from "./topTitle.vue?vue&type=template&id=2c1c88d4&scoped=true"
import script from "./topTitle.vue?vue&type=script&lang=js"
export * from "./topTitle.vue?vue&type=script&lang=js"
import style0 from "./topTitle.vue?vue&type=style&index=0&id=2c1c88d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c88d4",
  null
  
)

export default component.exports